function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import React, { useContext } from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { FiArrowRight } from "react-icons/fi";
import { Body, Heading } from "../../atoms";
import ReactConfigContext from "../../ReactConfigContext";
export default function SmallLinkImageCard(param) {
    var _param_variant = param.variant, variant = _param_variant === void 0 ? "image-first" : _param_variant, image = param.image, title = param.title, description = param.description, action = param.action, className = param.className;
    var _useContext = useContext(ReactConfigContext), _useContext_config = _useContext.config, LinkComponent = _useContext_config.LinkComponent, ImageComponent = _useContext_config.ImageComponent;
    var linkClassname = twMerge(variant === "image-first" && "grid gap-5 grid-cols-1 grid-flow-row auto-rows-max sm:grid-cols-[auto_1fr]", variant === "image-last" && "grid grid-cols-[1fr_10rem] md:grid-cols-[1fr_16rem]", action === null || action === void 0 ? void 0 : action.className);
    var _image_sizes;
    var cardContent = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === "image-first" && "pt-7 px-7 sm:p-7", variant === "image-last" && "order-last")
    }, /*#__PURE__*/ React.createElement(ImageComponent, _object_spread_props(_object_spread({}, image), {
        sizes: (_image_sizes = image.sizes) !== null && _image_sizes !== void 0 ? _image_sizes : "400px",
        className: twMerge("w-full h-full", variant === "image-first" && "object-contain object-left-top max-w-[3.4375rem]", variant === "image-last" && "object-cover object-center rounded-r-xl safari-fix-transform", image.className)
    }))), /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === "image-first" && "flex flex-col sm:justify-between sm:flex-row pb-7 px-7 sm:py-7 sm:pl-0 sm:pr-7", variant === "image-last" && "flex justify-between py-7 px-7")
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Heading, {
        as: "h3",
        variant: "h3"
    }, title), /*#__PURE__*/ React.createElement(Body, {
        className: "mt-5"
    }, description)), !!action && /*#__PURE__*/ React.createElement("div", {
        className: twMerge(variant === "image-first" && "mt-9 sm:pl-9 sm:mt-0")
    }, /*#__PURE__*/ React.createElement(FiArrowRight, null))));
    return /*#__PURE__*/ React.createElement("article", {
        className: twMerge("bg-bg-base rounded-xl transition-all outline-subtle-700 outline outline-0", !!action && "hover:shadow-xl hover:shadow-subtle-700 hover:outline-1", className)
    }, action ? /*#__PURE__*/ React.createElement(LinkComponent, _object_spread_props(_object_spread({}, action), {
        draggable: false,
        className: linkClassname
    }), cardContent) : /*#__PURE__*/ React.createElement("div", {
        className: linkClassname
    }, cardContent));
}

//# sourceMappingURL=SmallLinkImageCard.js.map